<script setup lang="ts">
import Logo from "~/components/Logo.vue";

interface Props {
  title?: string;
  showLogo?: boolean;
}

withDefaults(defineProps<Props>(), {
  showLogo: true,
});
</script>

<template>
  <div class="auth-card">
    <div v-if="showLogo" class="auth-card__logo">
      <Logo />
    </div>

    <div v-if="title || $slots.header" class="auth-card__header">
      <slot name="header">
        <h1 v-if="title" class="h2-primary auth-card__title">{{ title }}</h1>
      </slot>

      <div
        v-if="$slots.description"
        class="auth-card__description text-body-tertiary"
      >
        <slot name="description"></slot>
      </div>
    </div>

    <div class="auth-card__body">
      <slot></slot>
    </div>

    <div v-if="$slots.footer" class="auth-card__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.auth-card {
  width: 100%;
  max-width: 400px;
  padding: token("padding-2xlarge");
  border-radius: token("corner-radius-small");
  background: token("color-bg-surface");
  border: 1px solid token("color-border-neutral-alpha-light-default");

  display: flex;
  flex-direction: column;
  gap: token("gap-large");

  &__logo {
    display: flex;
    justify-content: center;
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: token("gap-xsmall");
  }

  &__title {
    text-align: center;
  }

  &__description {
    color: token("color-content-neutral-medium");
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: token("gap-medium");
  }

  &__footer {
    display: flex;
    justify-content: center;
    gap: token("gap-xsmall");
  }
}
</style>
